import { Route, Routes } from "react-router-dom";
import CrudPage from "./crud";
import ListPage from "./list";
import HotPage from "./hot";

export default function CategoryRouter() {
  return (
    <Routes>
      <Route path="" element={<ListPage />} />
      <Route path="/hot" element={<HotPage />} />
      <Route path="/detail/:id" element={<CrudPage />} />
      <Route path="/create" element={<CrudPage />} />
    </Routes>
  );
}
